if (!customElements.get('bf-hero-countdown')) {
  class BfHeroCountdown extends HTMLElement {
    connectedCallback() {
      const dateParts = (this.dataset.date || '').split('-');
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);
      const timeParts = (this.dataset.time || '0:0').split(':');
      const hour = parseInt(timeParts[0], 10) || 0;
      const minute = parseInt(timeParts[1], 10) || 0;
      const timezone = this.dataset.timezone || '';
      const dateString = month + '/' + day + '/' + year + ' ' + hour + ':' + minute + ' GMT' + timezone;

      this.countDownDate = new Date(dateString).getTime();
      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');

      this.updateTime();
      this.timer = window.setInterval(() => this.updateTime(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    updateTime() {
      const distance = this.countDownDate - Date.now();

      if (Number.isNaN(this.countDownDate) || distance < 60000) {
        window.clearInterval(this.timer);
        this.hidden = true;
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      this.setUnit(this.daysEl, days);
      this.setUnit(this.hoursEl, hours);
      this.setUnit(this.minutesEl, minutes);
    }

    setUnit(element, value) {
      if (!element) return;
      element.textContent = value < 10 ? '0' + value : String(value);
    }
  }

  customElements.define('bf-hero-countdown', BfHeroCountdown);
}
